<template>
	<events-section
		v-if="!stationsStore.isNoStations && isDesktop"
		:station-ids="stationIds"
	/>

	<div v-if="!isDesktop" class="hstack gap-3">
		<div class="p-2 ms-auto me-auto fs-6">
			Ця сторінка доступна тільки для великих екранів.
		</div>
	</div>
</template>




<script>
import EventsSection from '@/components/EventsSection/EventsSection.vue'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'


export default {
	components: {
		EventsSection
	},

	setup() {
		const stationsStore = useStationsStore()
		const { isDesktop } = useSizeBreakpoint()

		return {
			stationsStore,
			isDesktop
		}
	},

	async created() {
		if (this.stationsStore.isNoStations) {
			// Read all stations for station IDs list load
			await this.stationsStore.readStations()
		}
	},
	
	mounted() {
		document.title = "Журнал подій"
	},

	computed: {
		stationIds() {
			// return ['6850adb642ab2a5945dcc5d4', '6851c82704d01a8309192713',]
			return this.stationsStore.stationsArray
				.filter((el) => el.isActive)
				.map((el) => el.id)
		},
	},
}
</script>




<style scoped>
</style>